<template>
  <v-container tag="section" class="content">
    <v-card color="rgb(255, 255, 255, 0.3)" class="mt-2 mb-5 pa-3">
      <v-card-text
        v-if="$i18n.locale == 'de'"
        class="text-center"
        v-html="this.$store.state.modules.options.app_intro"
      >
      </v-card-text>
      <v-card-text
        v-else
        class="text-center"
        v-html="this.$store.state.modules.options.app_intro_it"
      >

      </v-card-text>
    </v-card>
    <v-row>
      <v-col class="d-flex justify-center">
        <v-btn x-large href="/aktuell" target="_blank" class="primary"><v-icon class="mr-2">mdi-download</v-icon> {{$t("actual_week_program")}}</v-btn>
      </v-col>
    </v-row>
    
    <!-- <v-row v-if="loading">
      <v-col>
        <v-progress-linear
          :color="currentColor()"
          indeterminate
        ></v-progress-linear>
      </v-col>
    </v-row>
    <template v-else>
        <v-alert dense type="info" v-if="items && items.length === 0">{{
          $t("no_result")
        }}</v-alert>
        <v-row
          v-else
          class="filters"
          :style="
            this.$store.state.modules.options.app_color
              ? 'background-color: ' +
                this.$store.state.modules.options.app_color +
                '!important;'
              : ''
          "
        >
        <v-col>
          Ausgabe Wochenprogramm
        </v-col>
        </v-row>
    </template> -->
  </v-container>
</template>

<script>
import { fetchItems } from "../shared/services";

export default {
  name: "app-frontend-list",
  data() {
    return {
      loading: false,
      options: {
        itemsPerPage: -1
      },
      total: 0,
      search: "",
      items: [],
    };
  },

  created() {
    //this.getData();
  },

  methods: {
    async getData() {
      this.loading = true;
      let response = await fetchItems({ ...this.options, search: this.search });
      if (response.data) {
        this.items = response.data;
      }

      this.loading = false;
    },
    currentColor() {
      return this.$store.state.modules.options.app_color
        ? this.$store.state.modules.options.app_color
        : "primary";
    }
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true
    },
    search: {
      handler() {
        this.getData();
      }
    }
  }
};
</script>

<style lang="scss" scoped>

.background {
  filter: blur(4px);
  position: absolute;
  width: 100%;
  height: 100%;
}

h1.main {
  font-size: 200%;
  line-height: 200%;
}
</style>
